<script>
export default {
  name: 'TutorListFilterImg'
}
</script>

<template>
  <BaseImg
    class="mx-auto lg:mx-0"
    :src="require('@images/public/tutor-list/tutor-list-header.webp')"
    :sizes="{lg:['397',225], xs: ['220','125']}"
  />
</template>

<style scoped lang="scss">

</style>
